import { useState } from "react";
import { CheckCircle, X } from "lucide-react";

export const CloseTicketModal = ({ ticket, onClose, onConfirm }) => {
  const [closingComments, setClosingComments] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(ticket.ticketId, closingComments);
  };

  return (
    <div className="modal-overlay" data-testid="close-ticket-modal-overlay" onClick={onClose}>
      <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2 className="modal-title">
              <CheckCircle size={20} />
              Close Ticket
            </h2>
            <p className="modal-subtitle">Ticket ID: {ticket.ticketId}</p>
          </div>
          <button className="modal-close-btn" onClick={onClose} data-testid="modal-close-btn">
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="ticket-form">
          <div className="form-section">
            <div className="ticket-summary">
              <div className="summary-row">
                <span className="summary-label">Device:</span>
                <span className="summary-value">{ticket.deviceId}</span>
              </div>
              <div className="summary-row">
                <span className="summary-label">Issue:</span>
                <span className="summary-value issue">{ticket.issueType}</span>
              </div>
              <div className="summary-row">
                <span className="summary-label">Assigned To:</span>
                <span className="summary-value">{ticket.assignedTo || 'Unassigned'}</span>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="form-section-title">Closing Comments</h3>
            <div className="form-row">
              <div className="form-group full-width">
                <label>Resolution Notes</label>
                <textarea 
                  value={closingComments} 
                  onChange={(e) => setClosingComments(e.target.value)}
                  className="form-textarea"
                  rows={4}
                  placeholder="Describe how the issue was resolved..."
                  required
                />
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-submit btn-close-ticket" data-testid="confirm-close-btn">
              <CheckCircle size={16} />
              Close Ticket
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
